import { TeeTimeSlot, TeeTimeSlotDisplay, ClubCourseData, TeeTimeBookingPlayer, RatingItem } from '../../../../data/mygolf.data';
import {
    Component,
    ElementRef,
    HostListener,
    Input,
    ViewChild
} from "@angular/core";
import { NavParams, ToastController, Platform, ModalController, LoadingController } from "@ionic/angular";
import { CourseInfo, CourseHoleInfo } from "../../../../data/club-course";
import { ClubFlightService } from "../../../../providers/club-flight-service/club-flight-service";
import { TeeTimeBooking, TeeTimePriceComponent, TeeTimePrice } from "../../../../data/mygolf.data";


import * as moment from "moment";
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { Router } from '@angular/router';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

import * as global from 'src/globals';


export interface RatingItemApp {
  itemId?: string;
  name?: string;
  rating?: number;
}


/**
 * Created by ashok on 19/12/16.
 */
@Component({
    templateUrl: 'club-ratings.html',
    selector: 'club-ratings-page',
    styleUrls: ['club-ratings.scss'],
})
export class ClubRatingsModal {
    @Input("value") courses: any;
    @Input() isModal: boolean = false;
    // @Input() courses: Array<CourseInfo>;
    forDate: string;
    isClub: boolean = false;
    courseId: number;
    teeSlot: Array<TeeTimeSlotDisplay>;
    startCourses: Array<ClubCourseData>;
    changeType: string;
    currentSlot: TeeTimeBooking;
    color: string;
    currentTime: string;
    currentDate: string;

    itemReq: number = 0;

    appFooterHide: boolean = true;

    itemsReq: Array<number> = [];

    additionalItems: Array<any> = [];
    pricingComponents: Array<TeeTimePriceComponent> = [];
    slotPrices: Array<TeeTimePrice> = [];
    bookingPlayer: TeeTimeBookingPlayer;

    mode: string = 'add';
    existingAddItems: Array<any> = [];
    initialItemValuesArray:any[] = [];
    fromClub: boolean = false;
    currencySymbol: string;
    clubRatingItems: Array<RatingItemApp> = new Array<RatingItemApp>();
    @Input() clubId: number;
    @Input() uniqCaddy: any;
    clubRating: number = 0;
    bookingRating: number = 0;
    caddyRating: Array<number> = new Array<number>();
    caddyRatingComment: Array<string> = new Array<string>();
    caddyRatingCommentOn: Array<boolean> = new Array<boolean>();
    doneRating: boolean = false;
    @ViewChild('myInput') myInput: ElementRef;
    myStuff: string = '';
    @Input() bookingSlot: TeeTimeBooking;
    @Input() currentPlayer: any;
    @Input() currentPlayerId: number;
    constructor(
        private flightService: ClubFlightService,
        private navParams: NavParams,
        private toastCtl: ToastController,
        private router: Router,
        private platform: Platform,
        private modalCtl: ModalController,
        private mg2uUtil: mygolfUtils,
        private loadingCtrl: LoadingController
        ) {

    }


    innerWidth: any;
    ngOnInit() {
        // this.initialItemValuesArray = JSON.parse(JSON.stringify(this.additionalItems));
        this.innerWidth = window.innerWidth;
        this.getClubRatingItems();

        for (let i = 0; i < this.uniqCaddy.length; i++) {
          this.caddyRating[i] = 0;
      }
    }

    getClubRatingItems() {
      this.clubRatingItems[0] = {
        itemId: '',
        name: '',
        rating: 0,
      };
      this.flightService
        .getClubRatingItems(this.clubId)
        .subscribe((data: Array<any>) => {
          if (data) {
            data.forEach((d, idx) => {
              this.clubRatingItems.push(
                Object.assign({}, this.clubRatingItems[idx], {
                  itemId: d.id,
                  name: d.name,
                  rating: 0,
                })
              );
            });
          }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    ionViewDidLoad() {
        // this.getTeeTimeBookingList();
    }
    close() {
        this.modalCtl.dismiss();
    }
    onAddItems() {
        let _params;
        let _bookingId = this.currentSlot.id;

        console.log('this.additionalItems: ', this.additionalItems);
        this.additionalItems.forEach((item) => {
            item['unitPrice'] = item['unitPriceUsed'];
        })
        if (this.mode === 'edit') {
            this.onRemoveItems()
                .then((result) => {
                    if (result) {
                        _params = this.additionalItems.filter((item) => {
                            return item.itemCount > 0
                        });
                        this.flightService.addUpdateAdditionalItems(_bookingId, _params)
                            .subscribe((data) => {
                                if (data) {
                                    console.log('this.isModal: ', this.isModal);
                                    if(this.isModal){
                                        console.log("IFFFFFF");

                                        this.modalCtl.dismiss(true);
                                      }else{
                                        console.log("ELSEEEEEEE");

                                        this.router.navigate(['booking-details']);
                                      }
                                }
                            })
                    }
                });
        } else {
            // _params = this.additionalItems;
            _params = this.additionalItems.filter((item) => {
                return item.itemCount > 0
            });
            this.flightService.addUpdateAdditionalItems(_bookingId, _params)
                .subscribe((data) => {
                    if (data) {
                        if(this.isModal){
                            this.modalCtl.dismiss(true);
                          }else{
                            this.router.navigate(['booking-details']);
                          }
                    }
                })
        }

    }
    onRemoveItems() {
        return new Promise((resolve, reject) => {
            if (!this.currentSlot) reject()
            let _itemsToRemove = [];
            this.additionalItems.filter((item) => {
                if (item.itemCount === 0)
                    return true
            }).map((item) => {
                _itemsToRemove.push(item.id)
            }); // .pop();
            this.additionalItems = this.additionalItems.filter((item) => {
                return item.itemCount > 0
            })

            let _bookingId = this.currentSlot.id;
            if (_itemsToRemove && _itemsToRemove.length > 0) {
                this.flightService.deleteAdditionalItems(_bookingId, _itemsToRemove)
                    .subscribe((data) => {

                        resolve(true)
                    })
            } else resolve(true)
        })
    }
    selectHole(hole: CourseHoleInfo, whichNine: number) {
        this.modalCtl.dismiss({
            hole: hole,
            whichNine: whichNine
        });
    }

    getTeeTimeBookingList() {
        let _clubCourseId;
        this.startCourses = []
        // let _courseId;
        // _courseId = this.courseId;
        let _currentDate;
        if (this.changeType === 'slotDate') _currentDate = this.currentDate;
        else _currentDate = this.forDate;


        _clubCourseId = this.isClub ? this.clubId : this.courseId
        this.flightService.getTeeTimeSlot(_currentDate, this.isClub, _clubCourseId)
            .subscribe((data: Array<TeeTimeSlotDisplay>) => {
                this.teeSlot = data;
                if (this.changeType === 'course') {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
                        return tee.slot.teeOffTime === this.currentSlot.slotAssigned.teeOffTime && tee.slot.startCourse.id !== this.currentSlot.slotAssigned.startCourse.id
                    })
                } else {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {

                        if (moment(tee.slot.teeOffDate, 'YYYY-MM-DD').format('YYYY-MM-DD') === this.forDate)
                            return tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
                        else return true
                        // && (tee.slot.teeOffDate === moment().toDate() && (moment(tee.slot.teeOffTime,'HH:mm:ss').format('HH:mm') >= moment().format('HH:mm')))
                    })
                }


                this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
                    this.startCourses.push(t.slot.startCourse);
                })

                this.startCourses = this.getUnique(this.startCourses, 'id')
                this.startCourses.sort((a, b) => {
                    if (a.displayOrder < b.displayOrder) return -1
                    if (a.displayOrder > b.displayOrder) return 1
                    else 0
                })





            })
    }

    getUnique(arr, comp) {

        // store the comparison  values in array
        const unique = arr.map(e => e[comp])

            // store the indexes of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the false indexes & return unique objects
            .filter((e) => arr[e]).map(e => arr[e]);

        return unique;
    }


    changeSlot(slot: TeeTimeSlotDisplay, type?: string) {

        if (!slot.available && type === 'slot' && this.changeType != 'slotDate') return false;
        // && type === 'course'
        this.flightService.getBookingFlightList(this.clubId, moment(slot.slot.teeOffDate).format('YYYY-MM-DD'), true)
            .subscribe((data) => {

                let _flightList: Array<TeeTimeBooking>
                let _hasFlight: Array<TeeTimeBooking>;
                if (data) {
                    _flightList = data.flightList;
                    _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
                        return (t.slotAssigned.slotNo === slot.slot.slotNo) && (t.slotAssigned.slotDayId === slot.slot.slotDayId)
                    })


                }
                if (_hasFlight && _hasFlight.length > 0) {


                    if (_hasFlight[0].flight && _hasFlight[0].flight.status === 'PlayFinished') {

                        MessageDisplayUtil.showMessageToast('There is Finished Flight in this slot. Please choose different slot.',
                            this.platform, this.toastCtl, 3000, "bottom");
                        return false;
                    } else {
                        this.modalCtl.dismiss({
                            newSlot: slot,
                            currentSlot: this.currentSlot
                        });
                    }

                } else {
                    this.modalCtl.dismiss({
                        newSlot: slot,
                        currentSlot: this.currentSlot
                    });
                }

            })
        // if(1) return false;

    }
    // changeSlot(slot: TeeTimeSlotDisplay) {
    //
    //     if(!slot.available) return false;
    //     this.viewCtrl.dismiss({
    //         newSlot: slot,
    //         currentSlot: this.currentSlot
    //     });
    // }

    getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
        switch (attribute) {
            case 'time':
                let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
        }
    }

    getCurrentSlotDetails(attribute) {
        switch (attribute) {
            case 'time':
                let _time = moment(this.currentSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
            case 'courseName':
                let _courseName = this.currentSlot.slotAssigned.startCourse.name;
                return _courseName;
            case 'date':
                let _date = moment(this.currentSlot.slotAssigned.teeOffDate).format("ddd, DD MMM YYYY")
                return _date;
        }
    }

    getSlotClass(slot: TeeTimeSlotDisplay) {
        // if(slot.available) this.color = 'danger';
        // else this.color = 'primary'

        if (this.changeType === 'course') return 'slot-available'
        else {
            // return this.color
            if (slot.available) return 'slot-available';
            else return 'slot-not-available'
        }
    }



    changeDate(x: number) {
        this.currentDate = moment(this.currentDate).add(x, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    nextDate() {
        this.currentDate = moment(this.currentDate).add(1, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    prevDate() {
        this.currentDate = moment(this.currentDate).subtract(1, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    confirmDate() {
        //
        this.getTeeTimeBookingList();
    }


    onAddItem(x: number, item: any) {
        // if(this.itemReq === 0 && x < 0) return;
        // this.itemReq += x;
        if (item.itemCount === 0 && x < 0) return;
        this.additionalItems.filter((items) => {
            return items === item
        }).map((items) => {
            items.itemCount += x;
        })
    }

    onToggleRemarks(item: any) {
        this.additionalItems.filter((items) => {
            return items === item
        }).map((items) => {
            items.remarkShow = !items.remarkShow;
        })
    }

    getTotalAdditionalItems() {
        let _total = 0;
        _total = this.additionalItems.filter((items) => {
            return items.itemCount > 0
        }).map((items) => {
            return items.itemCount * items.unitPriceUsed
        }).reduce((a, b) => {
            return a + b
        }, 0);



        return _total;
    }

    getSlotPrices() {

    }

    getPricingComponents() {

    }

    getAdditionalItemDetails(item: any, attribute: string) {

        switch (attribute) {
            case 'name':
                return item && item.itemName;
            case 'playerType':
                let _playerType = '';
                if (this.mode === 'edit')
                    if (item && item.bookingPlayer && item.bookingPlayer.playerType)
                        _playerType = item.bookingPlayer.playerType.name
                    else _playerType = item.playerType;
                else _playerType = item.playerType;
                if (_playerType) return "(" + _playerType + ")"
                else return "";
            default:
                return;
        }
    }

    getBookingPlayerDetails(player: TeeTimeBookingPlayer, attribute: string) {
        if (!player) return;
        if (!attribute) return;

        switch (attribute) {
            case 'playerType':
                let _playerType = player ? player.playerTypeUsed ? player.playerTypeUsed : player.playerType.name : ''
                return '(' + _playerType + ')';
            case 'name':
                let _playerName = player ? player.playerName : ""
                return _playerName;
            default:
                return;
        }
    }

    refresh(){
        this.additionalItems = JSON.parse(JSON.stringify(this.initialItemValuesArray));
    }


  setStar(type: string, x: number, attribute: string, idx?: number) {
    if (type === 'club') this.clubRating = x;
    else if (type === 'booking') this.bookingRating = x;
    else if (type === 'caddy' + idx) this.caddyRating[idx] = x;
    else if (type === 'clubItem' + idx) this.clubRatingItems[idx]['rating'] = x;
    //
  }

  getStar(type: string, x: number, attribute: string, idx?: number) {
    let _rating;
    if (type === 'club') _rating = this.clubRating;
    else if (type === 'booking') _rating = this.bookingRating;
    else if (type === 'caddy' + idx) _rating = this.caddyRating[idx];
    else if (type === 'clubItem' + idx)
      _rating = this.clubRatingItems[idx]['rating'];

    if (attribute === 'set') return x <= _rating;
    if (attribute === 'unset') return x > _rating;
  }


  onRateApp() {
    let _url = 'https://play.google.com/store/apps/details?id=com.brite.mygolf2u';
    if(this.platform.is('ios')) {
      _url = 'https://apps.apple.com/us/app/mygolf2u/id1092380543';
    }
    window.open(
      _url,
      '_system'
    );
    if (1) return false;
    if (
      (this.platform.is('ios') ||
        this.platform.is('android') ||
        this.platform.is('ipad') ||
        this.platform.is('iphone')) &&
      this.platform.is('capacitor')
    ) {
    } else if (this.platform) {
      window.open(
        'https://play.google.com/store/apps/details?id=com.brite.mygolf2u',
        '_system'
      );
    } else if (
      this.platform.is('android') &&
      (this.isMobileLayout() || this.platform.is('mobileweb'))
    ) {
    } else {
      window.open(
        'https://play.google.com/store/apps/details?id=com.brite.mygolf2u',
        '_system'
      );
    }
  }

  isMobileLayout() {
    return this.mg2uUtil.isMobileLayout();
  }

  resize() {
    this.myInput.nativeElement.style.height =
      this.myInput.nativeElement.scrollHeight + 'px';
  }

  async onRateSubmit() {
    let _caddyRateEmpty;
    _caddyRateEmpty = this.caddyRating.filter((a) => {
      return a === 0;
    });
    let _hasCaddy;
    _hasCaddy = this.uniqCaddy.filter((a: TeeTimeBookingPlayer) => {
      return a.caddyAssigned;
    });
    if (this.clubRating === 0) {
      MessageDisplayUtil.showMessageToast(
        'Please rate for Club Experience',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else if (
      _caddyRateEmpty &&
      _caddyRateEmpty.length > 0 &&
      _hasCaddy &&
      _hasCaddy.length > 0
    ) {
      MessageDisplayUtil.showMessageToast(
        'Please rate for each Caddy Experience',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    } else {
      let _clubRating = {};
      let _currentPlayer = this.bookingSlot.bookingPlayers.filter(
        (p: TeeTimeBookingPlayer) => {
          if (p.player) return p.player.id === this.currentPlayerId;
          else return false;
        }
      );
      this.clubRatingItems.shift();
      _clubRating['playerName'] = this.currentPlayer.playerName;
      _clubRating['playerEmail'] = this.currentPlayer.email;
      _clubRating['playerPhone'] = this.currentPlayer.phone;
      _clubRating['overallRating'] = this.clubRating;
      _clubRating['player'] = _currentPlayer[0].player;
      _clubRating['itemizedRatings'] = this.clubRatingItems;
      _clubRating['overallRating'] = this.clubRating;
      _clubRating['review'] = this.myStuff;
      let loader: any = await this.loadingCtrl.create({
        showBackdrop: false,
      });

      loader.present().then((response) => {
        this.flightService
          .rateForClub(this.bookingSlot.clubData.id, _clubRating)
          .subscribe((data) => {
            if (this.hasCaddyAssigned()) {
              this.uniqCaddy.forEach((c: TeeTimeBookingPlayer, idx: number) => {
                if (c.caddyAssigned) {
                  this.flightService
                    .rateForCaddy(
                      c.caddyAssigned.id,
                      this.caddyRating[idx],
                      this.currentPlayerId,
                      this.caddyRatingComment[idx]
                    )
                    .subscribe((dataCaddy) => {
                      if (dataCaddy && dataCaddy.status === 200) {
                      }
                    });
                }
              });
            }
            loader.dismiss().then(() => {
              // if (!!data) {
              if(1) {
                MessageDisplayUtil.showMessageToast(
                  'Thank you for rating us!',
                  this.platform,
                  this.toastCtl,
                  5000,
                  'bottom'
                );
                this.doneRating = true;
                this.modalCtl.dismiss();
              }
            });
          });
      });
    }
  }


  hasCaddyAssigned() {
    let _hasCaddy: any = null;
    _hasCaddy = this.uniqCaddy
      .filter((p: TeeTimeBookingPlayer) => {
        return p.caddyAssigned;
      })
      .map((p: TeeTimeBookingPlayer) => {
        return p.caddyAssigned;
      });
    if (_hasCaddy && _hasCaddy.length > 0) return true;
    else false;
  }


  getCaddyImage(caddy: any) {
    if(!caddy) return;
    let _caddyImage = '';
    if(caddy?.caddyAssigned) {
      _caddyImage = caddy?.caddyAssigned.caddyImage;
    }
    if(_caddyImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _caddyImage;
    else return global.MygolfServer + '/' + _caddyImage;
  }
}
